import {
	ActivityType,
	type ActivityLogPayload,
	type ErrorPayload,
} from "@repo/api/client";

export function isErrorPayload(
	payload: ActivityLogPayload | undefined,
): payload is ErrorPayload {
	if (payload === null || payload === undefined) return false;
	// Check type discriminator first, then fall back to property check for legacy payloads
	if ("type" in payload && payload.type === ActivityType.Error) return true;
	return "internalError" in payload;
}
